export const accessControl = {
  ac_type: "allow_or_block_device",
};

export default accessControl;
